import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _AbHealthInfoFactory;
/* eslint-disable */
/**
 * Health
 * Ab Initio Health Services
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/health.yaml
// Template file: models.mustache (typescript-fetch)

// @ts-ignore noUnusedLocals
import { AbHealthBaseObjFactory } from "./AbHealthBaseObj";
// @ts-ignore noUnusedLocals
import { AbHealthComponentInfoFactory } from "./AbHealthComponentInfo";

/**
 * Health status of the application. Can also optionally include health status of components.
 * @export
 * @interface AbHealthInfo
 */

export class AbHealthInfoFactory {}
_AbHealthInfoFactory = AbHealthInfoFactory;
_defineProperty(AbHealthInfoFactory, "FromJSON", function (json) {
  return _AbHealthInfoFactory.FromJSONTyped(json, false);
});
_defineProperty(AbHealthInfoFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'appStatus': AbHealthBaseObjFactory.FromJSON(json['appStatus']),
    'appBuildId': json['appBuildId'],
    'appName': json['appName'],
    'appVersion': json['appVersion'],
    'componentStatus': json['componentStatus'] === null || json['componentStatus'] === undefined ? json['componentStatus'] : json['componentStatus'].map(AbHealthComponentInfoFactory.FromJSON)
  };
});
_defineProperty(AbHealthInfoFactory, "ToJSON", function (value) {
  return _AbHealthInfoFactory.ToJSONTyped(false, value);
});
_defineProperty(AbHealthInfoFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'appStatus': AbHealthBaseObjFactory.ToJSON(value.appStatus),
    'appBuildId': value.appBuildId,
    'appName': value.appName,
    'appVersion': value.appVersion,
    'componentStatus': value.componentStatus === undefined ? undefined : value.componentStatus.map(AbHealthComponentInfoFactory.ToJSON)
  };
});
//# sourceMappingURL=AbHealthInfo.js.map
